import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetOperationsByIds = {
  operationIds: string[];
  fieldsToPopulate?: string[];
};

export const getOperationsByIds =
  ({ operationIds, fieldsToPopulate }: GetOperationsByIds) =>
  async (dispatch: Dispatch) => {
    try {
      const body = {
        ids: operationIds,
        fieldsToPopulate: fieldsToPopulate || [],
      };
      const { data } = await axiosV2.post('/operations/by-ids', body);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
